// frontend/src/pages/admin/lcl/components/IcsBadge.jsx
export default function IcsBadge({ status }) {
  const isOld = status === 'old';
  const cls = isOld
    ? 'bg-red-100 text-red-800'
    : 'bg-green-100 text-green-800';
  return (
    <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold ${cls}`}>
      {isOld ? 'Ancien ICS' : 'Nouveau ICS'}
    </span>
  );
}
